module.exports = __webpack_public_path__ + "img/loader.cea919e1.gif";